"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcAccountHeader = class UcAccountHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    account;
    onAccount(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("account");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    resourceTitle: this.$fn.pgettext("Account", "Account"),
                    newAccount: this.$fn.pgettext("Account", "New account"),
                },
                ux: null,
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.messages.resourceTitle;
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.account.isNew ? this.messages.newAccount : this.account.snapshot('name');
        }
        return null;
    }
    async act_6917646200545441_emit_6502_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_6917646200545441_clickPreventStop(event, scope) {
        return await this.actions.evh_6917646200545441_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_997556510679958_emit_6504_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_997556510679958_success(event, scope) {
        return await this.actions.evh_997556510679958_success.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_6917646200545441_emit_6502 = new core_1.actions.EmitAction({
            actionArgs: this.act_6917646200545441_emit_6502_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_6917646200545441_clickPreventStop_6501 = new core_1.actions.EventHandlerImpl({
            action: act_6917646200545441_emit_6502,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_6917646200545441_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6917646200545441_clickPreventStop_6501],
        });
        const act_997556510679958_emit_6504 = new core_1.actions.EmitAction({
            actionArgs: this.act_997556510679958_emit_6504_getActionArgs,
            events: [],
        });
        const evh_997556510679958_success_6503 = new core_1.actions.EventHandlerImpl({
            action: act_997556510679958_emit_6504,
            event: "success",
            displayName: "emit",
        });
        const evh_997556510679958_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_997556510679958_success_6503],
        });
        return {
            act_6917646200545441_emit_6502,
            evh_6917646200545441_clickPreventStop_6501,
            evh_6917646200545441_clickPreventStop,
            act_997556510679958_emit_6504,
            evh_997556510679958_success_6503,
            evh_997556510679958_success,
            reload: act_6917646200545441_emit_6502,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcAccountHeader.prototype, "account", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('account'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcAccountHeader.prototype, "onAccount", null);
UcAccountHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcAccountHeader);
exports.default = UcAccountHeader;
vue_property_decorator_1.Vue.component("UcAccountHeader", UcAccountHeader);
